import { render } from "./performance.vue?vue&type=template&id=b3ae15ec&ts=true"
import script from "./performance.vue?vue&type=script&lang=ts"
export * from "./performance.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__